// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const SpecialAllowanceClaimStatus = t.struct({
    account: t.maybe(t.String),
    accountAddress: t.maybe(t.String),
    accountCountry: t.maybe(t.String),
    accountName: t.maybe(t.String),
    amountOfUse: t.maybe(t.Number),
    claimNumber: t.maybe(t.String),
    claimStatus: t.maybe(t.String),
    claimStatusDescription: t.maybe(t.String),
    companyContribution: t.maybe(t.Number),
    creationDate: t.maybe(t.Number),
    creditMemo: t.maybe(t.String),
    creditMemoDate: t.maybe(t.Number),
    currency: t.maybe(t.String),
    customerContribution: t.maybe(t.Number),
    customerName: t.maybe(t.String),
    dealerContribution: t.maybe(t.Number),
    failureDate: t.maybe(t.Number),
    failurePart: t.maybe(t.String),
    failurePartDescription: t.maybe(t.String),
    internalDeereComments: t.maybe(t.String),
    netAmount: t.maybe(t.Number),
    originalSubmissionDate: t.maybe(t.Number),
    personResponsible: t.maybe(t.String),
    pin: t.maybe(t.String),
    reference1: t.maybe(t.String),
    reference2: t.maybe(t.String),
    repairDate: t.maybe(t.Number),
    repairNumber: t.maybe(t.String),
    specialAllowanceDescription: t.maybe(t.String),
    specialAllowanceType: t.maybe(t.String),
    submissionDate: t.maybe(t.Number),
    territory: t.maybe(t.String),
    unitOfMeasure: t.maybe(t.String),
    unitOfMeasureDescription: t.maybe(t.String)
}, {
    name: 'SpecialAllowanceClaimStatus',
    strict: true
});

export const getDefaultState = () => new SpecialAllowanceClaimStatus({});

export default SpecialAllowanceClaimStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/special-allowance-claim-status.js